export default import.meta.ROLLDOWN_FILE_URL_OHnE68zDsxVrAwzXN$bmCw